import { Data } from './data';
import { Article } from './article';

export class Commentaire extends Data {

    pseudo: string;
    contact: string;
    description: string;
    article: Article;

    constructor() {

        super();
        // this.montant = 0;
    }

    /* get text(): string{

        return this.designation;
    }

    get value(): number{

        return this.id;
    } */



}
